
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12682',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12682",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9766",
  "foundations-components": "static-1.8131",
  "foundations-components-legacy": "static-1.1156",
  "foundations-theming": "static-1.4533",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8122",
  "hub-http-shared-msw-handlers": "static-1.10209",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11577",
  "I18n": "static-7.1636",
  "jasmine-runner": "static-1.6562",
  "marketplace-storefront-base": "static-1.12745",
  "quartz": "static-1.7160",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16787",
  "reactive-variable-buffer-atom": "static-1.2963",
  "reporting-testing-lib": "static-1.9890",
  "settings-ui-lib": "static-1.12624",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7322",
  "ui-addon-i18n": "static-1.11254",
  "ui-addon-react-router-dom": "static-1.9643",
  "unified-auth": "static-1.613",
  "unified-auth-core-lib": "static-1.895",
  "usage-tracker": "static-1.7453",
  "usage-tracker-core": "static-1.7303",
  "customer-data-property-utils": "static-1.8200",
  "hub-http": "static-1.6325",
  "integrations-lib": "static-1.16481",
  "marketplace-ui-common": "static-1.20113",
  "property-management-iframe": "static-1.13507",
  "quartz-config": "static-1.938",
  "quartz-core": "static-1.6379",
  "quartz-routing": "static-1.590",
  "quick-fetch": "static-1.3994",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4757",
  "ts-schema": "static-1.4156",
  "ui-universal-auth": "static-1.9099",
  "UIComponents": "static-3.8523",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3473",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3437",
  "quartz-webpack": "static-1.3384",
  "bend-plugin-quartz-routing": "static-1.238",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4400",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4975",
  "foundations-theming-specialty": "static-1.2249",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9526",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.34",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5419",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2179",
  "ui-fonts": "static-1.839",
  "ui-images": "static-2.1178",
  "bend-plugin-foundations-theming": "static-1.3016",
  "foundations-theming-base": "static-1.3518",
  "stylex": "static-1.34",
  "HeadJS": "static-2.767",
  "hs-test-utils-bend-plugin": "static-1.3233",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4431",
  "ai-components-ui-library": "static-1.9204",
  "ai-rendering-library": "static-1.10526",
  "chirp-fetch": "static-1.1991",
  "connections-embed-lib": "static-1.1176",
  "copilot-toolkit": "static-1.11391",
  "feedback-loader": "static-1.29482",
  "laboratory-lib": "static-3.7257",
  "marketplace-embed": "static-1.22407",
  "marketplace-ui-details": "static-1.10008",
  "marketplace-ui-reviews": "static-1.20068",
  "marketplace-ui-tracking": "static-1.14283",
  "sanitize-text": "static-1.8248",
  "ui-addon-video-player": "static-1.8807",
  "usage-tracker-multi": "static-1.5867",
  "usage-tracker-session-replay": "static-1.5139",
  "wootric-nps": "static-1.7060",
  "quartz-head": "static-1.825",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4756",
  "immer": "static-1.33",
  "immerable": "static-1.4255",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67957",
  "cssUtils": "static-1.821",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11884",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10313",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10467",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7443",
  "icons": "static-2.652",
  "marketplace-ui-apps-core": "static-1.18645",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4616",
  "foundations-components-test-utils": "static-1.5614",
  "quartz-i18n": "static-1.835",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.322",
  "google-sheets-integration-lib": "static-1.530",
  "microsoft-drive-integration-lib": "static-1.666",
  "slack-ui-library": "static-1.10497",
  "fsm": "static-1.3833",
  "customer-data-objects": "static-1.7784",
  "property-translator": "static-1.5502",
  "hs-locale-management": "static-1.158",
  "frontend-preferences-client": "static-1.8030",
  "hs-promise-utils": "static-1.5696",
  "hubspot-apollo-client": "static-1.4983",
  "integrations-error-boundary-lib": "static-1.13896",
  "integrations-tracking-lib": "static-1.5709",
  "native-integrations-shared-strings": "static-1.7887",
  "reselect": "static-2.16",
  "sanitize": "static-1.4581",
  "superstore": "static-1.4865",
  "ui-shepherd-react": "static-3.10328",
  "ai-settings-ui-library": "static-1.8047",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4727",
  "immutable-less": "static-1.4758",
  "marketplace-ui-client-types": "static-1.17520",
  "nav-meta": "static-1.29899",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18135",
  "inbound-db-properties-service-client": "static-1.3922",
  "property-management-common": "static-1.5795",
  "ui-addon-iframeable": "static-1.9169",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.835",
  "quartz-test": "static-1.835",
  "quartz-tracking": "static-1.539",
  "trellis-components": "static-1.2198",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.167",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21771",
  "ContentUtils": "static-1.68646",
  "customer-data-objects-ui-components": "static-1.13133",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.340",
  "breeze-onboarding-components": "static-1.210",
  "avatar-components": "static-1.2602",
  "customer-data-filters-ui": "static-1.40131",
  "customer-data-reference-ui-components": "static-1.13276",
  "embedded-academy-lib": "static-1.14665",
  "ExportDialog": "static-6.10484",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41555",
  "reporting-snowflake": "static-1.56575",
  "reporting-ui-components": "static-2.65228",
  "reporting-visualizations": "static-1.60033",
  "ui-addon-teams": "static-1.21685",
  "integrations-reconnect-lib": "static-1.149",
  "magpie-lib": "static-1.5619",
  "navigation-components": "static-1.18262",
  "breeze-engine-lib": "static-1.1062",
  "magpie-types": "static-1.5079",
  "simple-logging-lib": "static-1.3155",
  "ai-studio-lib": "static-1.11905",
  "app-governance-lib": "static-1.1871",
  "developer-experience-shared-components": "static-1.10618",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8111",
  "ui-product-approvals": "static-1.28558",
  "ui-tool-access": "static-1.10252",
  "usage-based-billing-components-lib": "static-1.9367",
  "usage-tracker-anonymous": "static-1.5870",
  "usage-tracker-public": "static-1.7264",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3662",
  "persist-promise": "static-1.3803",
  "reference-resolvers": "static-1.8278",
  "ui-extensibility-client-types": "static-1.4029",
  "hubspot-apollo-cache": "static-1.442",
  "universal-page-editor-lib": "static-1.3122",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3059",
  "atom": "static-1.5179",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6071",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1646",
  "crm-component-utils": "static-1.39340",
  "crm-properties-common-lib": "static-1.5994",
  "customer-data-properties": "static-1.51919",
  "framework-data-schema-resolvers": "static-1.6993",
  "property-value-citations": "static-1.2533",
  "reference-resolvers-lite": "static-1.8201",
  "ui-business-units-lib": "static-1.9165",
  "navigation-messaging": "static-1.7589",
  "hubspotter-http-shared-msw-handlers": "static-1.10207",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1046",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4918",
  "content-icons-ui": "static-1.2255",
  "customer-data-ui-utilities": "static-1.9929",
  "conversations-skeleton-state": "static-1.7352",
  "crm-message-bus": "static-1.43238",
  "customer-data-filters-ui-msw-helpers": "static-1.22566",
  "events-data-lib": "static-1.336",
  "FormUrlGenerator": "static-2.4826",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6898",
  "multi-account-reference-resolvers": "static-1.1086",
  "onboarding-tours": "static-1.16791",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13964",
  "academy-common-lib": "static-1.14125",
  "content-assistance-lib": "static-1.7913",
  "dashboard-lib": "static-1.81921",
  "file-manager-components": "static-1.23890",
  "getting-started-shared-tasks": "static-1.18689",
  "hubspot-prosemirror": "static-1.18507",
  "hubspot-prosemirror-plugins": "static-1.18499",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20005",
  "share-with-third-party-component-lib": "static-1.8807",
  "ui-addon-draggable": "static-3.4864",
  "ui-asset-management-lib": "static-1.11165",
  "user-context": "static-1.5214",
  "growth-payments-core": "static-1.25671",
  "reporting-plugins": "static-1.10491",
  "reporting-reports": "static-1.67635",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.829",
  "nest": "static-1.336",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10732",
  "framework-listing-lib": "static-2.28975",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30953",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4356",
  "react-dnd-compat": "static-1.4720",
  "ui-product-approvals-common": "static-1.453",
  "onboarding-scopes": "static-1.6564",
  "onboarding-tours-client": "static-1.5005",
  "platform-infra-nav-components": "static-1.7748",
  "subscription-experience-data-types": "static-1.15054",
  "crm-record-cards-service-types": "static-1.3665",
  "location-customization-utils-lib": "static-1.9551",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6074",
  "signup-constants": "static-1.19076",
  "signup-ui-url-generator": "static-2.8161",
  "card-properties-lib": "static-1.44493",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6443",
  "crm-cards-sdk": "static-1.43876",
  "customer-data-properties-shared-msw-handlers": "static-1.9536",
  "customer-data-tracking": "static-1.6994",
  "hs-resources": "static-1.278",
  "pulse": "static-1.699",
  "calling-global-api": "static-1.64857",
  "calling-internal-common": "static-1.31414",
  "calling-lifecycle-internal": "static-1.66239",
  "calling-lifecycle-messages": "static-1.58533",
  "commerce-products-lib": "static-1.9912",
  "conditional-properties-service-client": "static-1.3873",
  "crm-links": "static-1.6411",
  "crm-pipelines-api-client-types": "static-1.4215",
  "external-options-client-types": "static-1.4205",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4293",
  "meetings-icalendar-utils-lib": "static-1.739",
  "multi-currency-client-types": "static-1.3767",
  "object-builder-ui-client": "static-1.49088",
  "pipeline-validation-client-types": "static-1.4042",
  "smart-property-lib": "static-1.7721",
  "tiered-pricing": "static-1.1462",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11093",
  "fdsr-migration-layer": "static-1.112",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1130",
  "growth-data-modal": "static-1.5588",
  "growth-onboarding-confetti": "static-1.3169",
  "growth-onboarding-next-action-utils": "static-1.2211",
  "onboarding-tours-utils": "static-1.857",
  "ui-shepherd-tracker": "static-1.7709",
  "academy-service-client": "static-1.3787",
  "SafeStorage": "static-1.4504",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39389",
  "FileManagerLib": "static-1.39530",
  "video-embed": "static-1.36094",
  "ui-coaching-tips": "static-1.28839",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11602",
  "video-data-lib": "static-1.35260",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23776",
  "ui-addon-emoji-picker": "static-1.9990",
  "EmailSignatureEditor": "static-1.24592",
  "viral-links-lib": "static-1.7173",
  "data-token-picker": "static-1.16584",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.328",
  "timezone-utils": "static-2.5347",
  "seat-types-lib": "static-1.247",
  "getting-started-shared-tasks-store": "static-1.17807",
  "ui-addon-opt": "static-4.8465",
  "campaign-roi-lib": "static-1.9383",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25653",
  "framework-data-table": "static-2.12144",
  "marketing-platform-lib": "static-1.6969",
  "nudge-client-utils": "static-1.2792",
  "nudge-custom-ui-functions": "static-1.1206",
  "switchboard-lib": "static-1.327",
  "app-users-service-client": "static-1.5712",
  "app-users-service-types": "static-1.5120",
  "mini-checkout-client": "static-1.27058",
  "onboarding-utils": "static-1.5463",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28824",
  "edison-service-client-types": "static-1.493",
  "crm_data": "static-4.92275",
  "customer-data-sidebar": "static-2.46288",
  "enrichment-properties-lib": "static-1.16839",
  "ui-addon-draggable-compat": "static-2.4364",
  "universal-record-utils-lib": "static-1.1196",
  "commerce-billing-lib": "static-1.19402",
  "commerce-shared-components-lib": "static-1.18768",
  "commerce-tools-ui-lib": "static-1.10645",
  "crm-fe-perf": "static-1.23008",
  "event-emitter": "static-1.1054",
  "bend-plugin-pulse": "static-1.202",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31421",
  "shared-worker-versioning": "static-1.11140",
  "calling-usage-tracker": "static-1.6648",
  "voice-sms-access-library": "static-1.1392",
  "commerce-permissions": "static-1.882",
  "products-iframe-lib": "static-1.8212",
  "products-ui-components-shared-msw-handlers": "static-1.10591",
  "data-agent-kit": "static-1.358",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10292",
  "policy-lib": "static-1.6886",
  "react-tinymce": "static-1.55507",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10355",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54633",
  "tinymce-plugins": "static-1.57747",
  "tinymce-themes": "static-1.56603",
  "onboarding-data-sync-lib": "static-1.2133",
  "growth-onboarding-next-action-components": "static-1.2239",
  "user-context-client": "static-1.4685",
  "audio-components": "static-1.6071",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37041",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4640",
  "video-components": "static-1.13604",
  "outpost": "static-1.4274",
  "growth-onboarding-feedback-components": "static-1.6684",
  "content-media-composition-data-lib": "static-1.12629",
  "content-media-compositions": "static-2.16636",
  "media-bridge-lib": "static-1.19100",
  "commerce-tours-lib": "static-1.6283",
  "growth-onboarding-reliability": "static-1.5186",
  "sales-checkout-service-client": "static-1.3695",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21851",
  "sales-email-signature-service-client": "static-1.3952",
  "ts-utils-lib": "static-1.277",
  "crm-export-dialog": "static-1.6389",
  "crm-index-associations-lib": "static-1.6546",
  "crm-view-components": "static-1.579",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7435",
  "nudge-custom-function-registry": "static-1.2549",
  "nudge-renderer-utils": "static-1.2868",
  "whisper-core-api": "static-1.6838",
  "InboxConnectUtils": "static-4.15074",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5769",
  "settings-content-modals": "static-1.46364",
  "crm_universal": "static-1.22184",
  "customer-data-email": "static-1.18212",
  "card-payment-highlight-lib": "static-1.37454",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12558",
  "invoices-highlight-card-lib": "static-1.55052",
  "orders-highlight-card-lib": "static-1.21741",
  "products-highlight-card-lib": "static-1.18195",
  "quotes-highlight-card-lib": "static-1.72350",
  "crm-source-interpretation-lib": "static-1.5447",
  "crm-object-search-query-utilities": "static-1.9805",
  "utility-belt": "static-1.2636",
  "payments-enrollment-embed-lib": "static-1.23207",
  "stripe-embedded-components": "static-1.7685",
  "customer-data-rte": "static-1.33258",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5923",
  "payments-post-enroll-local-storage-lib": "static-1.5210",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38440",
  "trials-service-types": "static-1.3985",
  "calling-orchestration-schema": "static-1.36169",
  "sales-views-client-types": "static-1.4359",
  "hub-http-contrib": "static-1.3147",
  "interframe": "static-3.4864",
  "tinymce-data": "static-1.40718",
  "ui-addon-sales-email": "static-1.5315",
  "layout-dnd-components": "static-1.12638",
  "layout-dnd-utils": "static-1.11613",
  "ui-brand-identity-lib": "static-1.15633",
  "NamespacedHubStyle": "static-2.9133",
  "meetings-connect-utils-lib": "static-1.7709",
  "social-insights-client-types": "static-1.22318",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4270",
  "checkout-sdk": "static-3.23901",
  "checkout-service-types": "static-1.3873",
  "company-details-components": "static-1.6301",
  "payment-method-components": "static-1.6977",
  "pricing-pages-ui-components": "static-1.14638",
  "quote-checkout-service-types": "static-1.3568",
  "upgrade-catalog-service-types": "static-1.3625",
  "access-control-lib": "static-1.10539",
  "EmailComponents": "static-1.55043",
  "EmailData": "static-1.53720",
  "redux-less": "static-2.9587",
  "sequences-lib": "static-1.8221",
  "ui-gdpr-components": "static-1.10455",
  "products-ui-components": "static-1.40430",
  "accounting-integrations-ui-components": "static-1.7228",
  "invoices-ui-lib": "static-1.55068",
  "commerce-products-api": "static-1.2440",
  "invoices-iframe-lib": "static-1.57126",
  "quotes-modal-lib": "static-1.103028",
  "quotes-ui-lib": "static-1.81071",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28527",
  "ContentData": "static-1.68721",
  "layout-data-lib": "static-1.9938",
  "hub-http-rxjs": "static-1.808",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4041",
  "billing-payments-client-types": "static-1.4095",
  "react-performance-metrics-lib": "static-1.659",
  "account-and-billing-fintech-outages": "static-3.18708",
  "pricing-pages-api": "static-1.14503",
  "ContentComponents": "static-2.71602",
  "marketing-contacts-lib": "static-1.10381",
  "marketing-email-service-types": "static-1.1979",
  "messaging-editing-lib": "static-1.46551",
  "messaging-usage-based-billing-components-lib": "static-1.1413",
  "automation-ui-source-apps": "static-1.19171",
  "automation-ui-types": "static-1.20089",
  "messaging-types-lib": "static-1.46288",
  "onboarding-settings-client": "static-1.4606",
  "sequences-client-types-lib": "static-1.8078",
  "commerce-tax-lib": "static-1.640",
  "price-books-api": "static-1.1196",
  "price-books-components": "static-1.1254",
  "property-description-translator": "static-1.3946",
  "ramp-editor": "static-1.396",
  "commerce-analytics-service-client": "static-1.3683",
  "totals-ui-components": "static-1.23869",
  "SalesContentIndexUI": "static-3.9389",
  "advanced-menus-core": "static-1.15291",
  "advanced-menus-lib": "static-1.12205",
  "ui-memberships-settings-lib": "static-1.34315",
  "segments-query-core": "static-1.1524",
  "automation-ui-ubb": "static-1.6005",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7443",
  "data-token-views": "static-1.16565",
  "forms-utils-lib": "static-1.12770",
  "payments-embed-points-lib": "static-1.13241",
  "simple-menus-core": "static-1.15290",
  "simple-menus-lib": "static-1.16807",
  "videoconference-integration-components": "static-1.6963",
  "marketing-contacts-client": "static-1.7618",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2628",
  "ContentEditorUI": "static-2.77387",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13935",
  "web-interactives-data": "static-1.13936",
  "messaging-shared-utils-lib": "static-1.862",
  "messaging-user-info-utils-lib": "static-1.1032",
  "email-portal-health-service-types": "static-1.1080",
  "line-items-api": "static-1.843",
  "commerce-totals-service-types": "static-1.3895",
  "FireAlarmUi": "static-1.4585",
  "sales-templates-service-types-lib": "static-1.4245",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22025",
  "automation-ui-usage-tracking": "static-1.21488",
  "data-studio-ubb": "static-1.3008",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27247",
  "collaboration-sidebar": "static-1.58133",
  "content-management-data-lib": "static-1.5572",
  "copilot-plugins": "static-1.11364",
  "cta-picker": "static-1.36664",
  "customer-agent-discovery-components-lib": "static-1.3372",
  "editor-components": "static-1.13373",
  "editor-iframe-lib": "static-1.8540",
  "error-messaging-js": "static-1.5295",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10749",
  "SharedLegalStrings": "static-1.1848",
  "smart-content-core": "static-1.42711",
  "smart-content-lib": "static-1.43364",
  "social-composer-lib": "static-1.59515",
  "structured-content-lib": "static-1.25454",
  "theme-previewer-lib": "static-1.53514",
  "tinymce-copilot": "static-1.16701",
  "xray-recommendation-lib": "static-1.8040",
  "automation-ui-routing": "static-1.21446",
  "sql-reporting-client-types": "static-1.5719",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42408",
  "campaigns-utils-lib": "static-1.3292",
  "reporting-enablement": "static-1.23267",
  "chatspot-widget-iframe": "static-1.21762",
  "collaboration-sidebar-common": "static-1.2930",
  "forms-ai-lib": "static-1.4477",
  "codemirror-dlb": "static-1.58946",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6539",
  "report-customization-components": "static-1.13439",
  "data-quality-ui-library": "static-1.13294",
  "reporting-filters": "static-1.570",
  "reporting-insights-lib": "static-1.2034"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12682",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9766",
  "foundations-components": "/foundations-components/static-1.8131",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1156",
  "foundations-theming": "/foundations-theming/static-1.4533",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8122",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10209",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11577",
  "I18n": "/I18n/static-7.1636",
  "jasmine-runner": "/jasmine-runner/static-1.6562",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12745",
  "quartz": "/quartz/static-1.7160",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16787",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2963",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9890",
  "settings-ui-lib": "/settings-ui-lib/static-1.12624",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7322",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11254",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9643",
  "unified-auth": "/unified-auth/static-1.613",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.895",
  "usage-tracker": "/usage-tracker/static-1.7453",
  "usage-tracker-core": "/usage-tracker-core/static-1.7303",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8200",
  "hub-http": "/hub-http/static-1.6325",
  "integrations-lib": "/integrations-lib/static-1.16481",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20113",
  "property-management-iframe": "/property-management-iframe/static-1.13507",
  "quartz-config": "/quartz-config/static-1.938",
  "quartz-core": "/quartz-core/static-1.6379",
  "quartz-routing": "/quartz-routing/static-1.590",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4757",
  "ts-schema": "/ts-schema/static-1.4156",
  "ui-universal-auth": "/ui-universal-auth/static-1.9099",
  "UIComponents": "/UIComponents/static-3.8523",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3473",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3437",
  "quartz-webpack": "/quartz-webpack/static-1.3384",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.238",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4400",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4975",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2249",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9526",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5419",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2179",
  "ui-fonts": "/ui-fonts/static-1.839",
  "ui-images": "/ui-images/static-2.1178",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3016",
  "foundations-theming-base": "/foundations-theming-base/static-1.3518",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.767",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3233",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4431",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9204",
  "ai-rendering-library": "/ai-rendering-library/static-1.10526",
  "chirp-fetch": "/chirp-fetch/static-1.1991",
  "connections-embed-lib": "/connections-embed-lib/static-1.1176",
  "copilot-toolkit": "/copilot-toolkit/static-1.11391",
  "feedback-loader": "/feedback-loader/static-1.29482",
  "laboratory-lib": "/laboratory-lib/static-3.7257",
  "marketplace-embed": "/marketplace-embed/static-1.22407",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10008",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20068",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14283",
  "sanitize-text": "/sanitize-text/static-1.8248",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8807",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5867",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5139",
  "wootric-nps": "/wootric-nps/static-1.7060",
  "quartz-head": "/quartz-head/static-1.825",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4756",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4255",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67957",
  "cssUtils": "/cssUtils/static-1.821",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11884",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10313",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10467",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7443",
  "icons": "/icons/static-2.652",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18645",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4616",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5614",
  "quartz-i18n": "/quartz-i18n/static-1.835",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.322",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.530",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.666",
  "slack-ui-library": "/slack-ui-library/static-1.10497",
  "fsm": "/fsm/static-1.3833",
  "customer-data-objects": "/customer-data-objects/static-1.7784",
  "property-translator": "/property-translator/static-1.5502",
  "hs-locale-management": "/hs-locale-management/static-1.158",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8030",
  "hs-promise-utils": "/hs-promise-utils/static-1.5696",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4983",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13896",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5709",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7887",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4581",
  "superstore": "/superstore/static-1.4865",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10328",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8047",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4727",
  "immutable-less": "/immutable-less/static-1.4758",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17520",
  "nav-meta": "/nav-meta/static-1.29899",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18135",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "property-management-common": "/property-management-common/static-1.5795",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9169",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.835",
  "quartz-test": "/quartz-test/static-1.835",
  "quartz-tracking": "/quartz-tracking/static-1.539",
  "trellis-components": "/trellis-components/static-1.2198",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.167",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21771",
  "ContentUtils": "/ContentUtils/static-1.68646",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13133",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.340",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.210",
  "avatar-components": "/avatar-components/static-1.2602",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40131",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13276",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14665",
  "ExportDialog": "/ExportDialog/static-6.10484",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41555",
  "reporting-snowflake": "/reporting-snowflake/static-1.56575",
  "reporting-ui-components": "/reporting-ui-components/static-2.65228",
  "reporting-visualizations": "/reporting-visualizations/static-1.60033",
  "ui-addon-teams": "/ui-addon-teams/static-1.21685",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.149",
  "magpie-lib": "/magpie-lib/static-1.5619",
  "navigation-components": "/navigation-components/static-1.18262",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1062",
  "magpie-types": "/magpie-types/static-1.5079",
  "simple-logging-lib": "/simple-logging-lib/static-1.3155",
  "ai-studio-lib": "/ai-studio-lib/static-1.11905",
  "app-governance-lib": "/app-governance-lib/static-1.1871",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10618",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8111",
  "ui-product-approvals": "/ui-product-approvals/static-1.28558",
  "ui-tool-access": "/ui-tool-access/static-1.10252",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9367",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5870",
  "usage-tracker-public": "/usage-tracker-public/static-1.7264",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3662",
  "persist-promise": "/persist-promise/static-1.3803",
  "reference-resolvers": "/reference-resolvers/static-1.8278",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4029",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.442",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3122",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3059",
  "atom": "/atom/static-1.5179",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6071",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1646",
  "crm-component-utils": "/crm-component-utils/static-1.39340",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5994",
  "customer-data-properties": "/customer-data-properties/static-1.51919",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6993",
  "property-value-citations": "/property-value-citations/static-1.2533",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8201",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9165",
  "navigation-messaging": "/navigation-messaging/static-1.7589",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10207",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1046",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4918",
  "content-icons-ui": "/content-icons-ui/static-1.2255",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9929",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7352",
  "crm-message-bus": "/crm-message-bus/static-1.43238",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22566",
  "events-data-lib": "/events-data-lib/static-1.336",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4826",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6898",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1086",
  "onboarding-tours": "/onboarding-tours/static-1.16791",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13964",
  "academy-common-lib": "/academy-common-lib/static-1.14125",
  "content-assistance-lib": "/content-assistance-lib/static-1.7913",
  "dashboard-lib": "/dashboard-lib/static-1.81921",
  "file-manager-components": "/file-manager-components/static-1.23890",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18689",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18507",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18499",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20005",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8807",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4864",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11165",
  "user-context": "/user-context/static-1.5214",
  "growth-payments-core": "/growth-payments-core/static-1.25671",
  "reporting-plugins": "/reporting-plugins/static-1.10491",
  "reporting-reports": "/reporting-reports/static-1.67635",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.829",
  "nest": "/nest/static-1.336",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10732",
  "framework-listing-lib": "/framework-listing-lib/static-2.28975",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30953",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4356",
  "react-dnd-compat": "/react-dnd-compat/static-1.4720",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.453",
  "onboarding-scopes": "/onboarding-scopes/static-1.6564",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5005",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7748",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15054",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3665",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9551",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6074",
  "signup-constants": "/signup-constants/static-1.19076",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8161",
  "card-properties-lib": "/card-properties-lib/static-1.44493",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6443",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43876",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9536",
  "customer-data-tracking": "/customer-data-tracking/static-1.6994",
  "hs-resources": "/hs-resources/static-1.278",
  "pulse": "/pulse/static-1.699",
  "calling-global-api": "/calling-global-api/static-1.64857",
  "calling-internal-common": "/calling-internal-common/static-1.31414",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66239",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58533",
  "commerce-products-lib": "/commerce-products-lib/static-1.9912",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-links": "/crm-links/static-1.6411",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "external-options-client-types": "/external-options-client-types/static-1.4205",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4293",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.739",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49088",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4042",
  "smart-property-lib": "/smart-property-lib/static-1.7721",
  "tiered-pricing": "/tiered-pricing/static-1.1462",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11093",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.112",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1130",
  "growth-data-modal": "/growth-data-modal/static-1.5588",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3169",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2211",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.857",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7709",
  "academy-service-client": "/academy-service-client/static-1.3787",
  "SafeStorage": "/SafeStorage/static-1.4504",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39389",
  "FileManagerLib": "/FileManagerLib/static-1.39530",
  "video-embed": "/video-embed/static-1.36094",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28839",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11602",
  "video-data-lib": "/video-data-lib/static-1.35260",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23776",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9990",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24592",
  "viral-links-lib": "/viral-links-lib/static-1.7173",
  "data-token-picker": "/data-token-picker/static-1.16584",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.328",
  "timezone-utils": "/timezone-utils/static-2.5347",
  "seat-types-lib": "/seat-types-lib/static-1.247",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17807",
  "ui-addon-opt": "/ui-addon-opt/static-4.8465",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9383",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25653",
  "framework-data-table": "/framework-data-table/static-2.12144",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6969",
  "nudge-client-utils": "/nudge-client-utils/static-1.2792",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1206",
  "switchboard-lib": "/switchboard-lib/static-1.327",
  "app-users-service-client": "/app-users-service-client/static-1.5712",
  "app-users-service-types": "/app-users-service-types/static-1.5120",
  "mini-checkout-client": "/mini-checkout-client/static-1.27058",
  "onboarding-utils": "/onboarding-utils/static-1.5463",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28824",
  "edison-service-client-types": "/edison-service-client-types/static-1.493",
  "crm_data": "/crm_data/static-4.92275",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46288",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16839",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4364",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1196",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19402",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18768",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10645",
  "crm-fe-perf": "/crm-fe-perf/static-1.23008",
  "event-emitter": "/event-emitter/static-1.1054",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.202",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31421",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11140",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6648",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1392",
  "commerce-permissions": "/commerce-permissions/static-1.882",
  "products-iframe-lib": "/products-iframe-lib/static-1.8212",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10591",
  "data-agent-kit": "/data-agent-kit/static-1.358",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10292",
  "policy-lib": "/policy-lib/static-1.6886",
  "react-tinymce": "/react-tinymce/static-1.55507",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10355",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54633",
  "tinymce-plugins": "/tinymce-plugins/static-1.57747",
  "tinymce-themes": "/tinymce-themes/static-1.56603",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2133",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2239",
  "user-context-client": "/user-context-client/static-1.4685",
  "audio-components": "/audio-components/static-1.6071",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37041",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4640",
  "video-components": "/video-components/static-1.13604",
  "outpost": "/outpost/static-1.4274",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6684",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12629",
  "content-media-compositions": "/content-media-compositions/static-2.16636",
  "media-bridge-lib": "/media-bridge-lib/static-1.19100",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6283",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5186",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3695",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21851",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3952",
  "ts-utils-lib": "/ts-utils-lib/static-1.277",
  "crm-export-dialog": "/crm-export-dialog/static-1.6389",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6546",
  "crm-view-components": "/crm-view-components/static-1.579",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7435",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2549",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2868",
  "whisper-core-api": "/whisper-core-api/static-1.6838",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15074",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5769",
  "settings-content-modals": "/settings-content-modals/static-1.46364",
  "crm_universal": "/crm_universal/static-1.22184",
  "customer-data-email": "/customer-data-email/static-1.18212",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37454",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12558",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55052",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21741",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18195",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72350",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5447",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9805",
  "utility-belt": "/utility-belt/static-1.2636",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23207",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7685",
  "customer-data-rte": "/customer-data-rte/static-1.33258",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5923",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5210",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38440",
  "trials-service-types": "/trials-service-types/static-1.3985",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36169",
  "sales-views-client-types": "/sales-views-client-types/static-1.4359",
  "hub-http-contrib": "/hub-http-contrib/static-1.3147",
  "interframe": "/interframe/static-3.4864",
  "tinymce-data": "/tinymce-data/static-1.40718",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5315",
  "layout-dnd-components": "/layout-dnd-components/static-1.12638",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11613",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15633",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7709",
  "social-insights-client-types": "/social-insights-client-types/static-1.22318",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4270",
  "checkout-sdk": "/checkout-sdk/static-3.23901",
  "checkout-service-types": "/checkout-service-types/static-1.3873",
  "company-details-components": "/company-details-components/static-1.6301",
  "payment-method-components": "/payment-method-components/static-1.6977",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14638",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3568",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3625",
  "access-control-lib": "/access-control-lib/static-1.10539",
  "EmailComponents": "/EmailComponents/static-1.55043",
  "EmailData": "/EmailData/static-1.53720",
  "redux-less": "/redux-less/static-2.9587",
  "sequences-lib": "/sequences-lib/static-1.8221",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10455",
  "products-ui-components": "/products-ui-components/static-1.40430",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7228",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55068",
  "commerce-products-api": "/commerce-products-api/static-1.2440",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57126",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103028",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81071",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28527",
  "ContentData": "/ContentData/static-1.68721",
  "layout-data-lib": "/layout-data-lib/static-1.9938",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.808",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4041",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4095",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.659",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18708",
  "pricing-pages-api": "/pricing-pages-api/static-1.14503",
  "ContentComponents": "/ContentComponents/static-2.71602",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10381",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1979",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46551",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1413",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19171",
  "automation-ui-types": "/automation-ui-types/static-1.20089",
  "messaging-types-lib": "/messaging-types-lib/static-1.46288",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4606",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8078",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.640",
  "price-books-api": "/price-books-api/static-1.1196",
  "price-books-components": "/price-books-components/static-1.1254",
  "property-description-translator": "/property-description-translator/static-1.3946",
  "ramp-editor": "/ramp-editor/static-1.396",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3683",
  "totals-ui-components": "/totals-ui-components/static-1.23869",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9389",
  "advanced-menus-core": "/advanced-menus-core/static-1.15291",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12205",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34315",
  "segments-query-core": "/segments-query-core/static-1.1524",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6005",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7443",
  "data-token-views": "/data-token-views/static-1.16565",
  "forms-utils-lib": "/forms-utils-lib/static-1.12770",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13241",
  "simple-menus-core": "/simple-menus-core/static-1.15290",
  "simple-menus-lib": "/simple-menus-lib/static-1.16807",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6963",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7618",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2628",
  "ContentEditorUI": "/ContentEditorUI/static-2.77387",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13935",
  "web-interactives-data": "/web-interactives-data/static-1.13936",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.862",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1032",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1080",
  "line-items-api": "/line-items-api/static-1.843",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3895",
  "FireAlarmUi": "/FireAlarmUi/static-1.4585",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4245",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22025",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21488",
  "data-studio-ubb": "/data-studio-ubb/static-1.3008",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27247",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58133",
  "content-management-data-lib": "/content-management-data-lib/static-1.5572",
  "copilot-plugins": "/copilot-plugins/static-1.11364",
  "cta-picker": "/cta-picker/static-1.36664",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3372",
  "editor-components": "/editor-components/static-1.13373",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8540",
  "error-messaging-js": "/error-messaging-js/static-1.5295",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10749",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1848",
  "smart-content-core": "/smart-content-core/static-1.42711",
  "smart-content-lib": "/smart-content-lib/static-1.43364",
  "social-composer-lib": "/social-composer-lib/static-1.59515",
  "structured-content-lib": "/structured-content-lib/static-1.25454",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53514",
  "tinymce-copilot": "/tinymce-copilot/static-1.16701",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8040",
  "automation-ui-routing": "/automation-ui-routing/static-1.21446",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5719",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42408",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3292",
  "reporting-enablement": "/reporting-enablement/static-1.23267",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21762",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2930",
  "forms-ai-lib": "/forms-ai-lib/static-1.4477",
  "codemirror-dlb": "/codemirror-dlb/static-1.58946",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6539",
  "report-customization-components": "/report-customization-components/static-1.13439",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13294",
  "reporting-filters": "/reporting-filters/static-1.570",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2034"
}
};
